import React from 'react';
import { shape } from 'prop-types';

import { Placeholder } from '@thd-olt-component-react/core-ui';
import { StoreName } from './store-name';
import { StoreDistance } from './store-distance';
import { StoreAddress } from './store-address';

import './store-details.scss';

export const StoreDetails = ({ store }) => {

  const {
    address,
    distance,
    name,
    storeId
  } = store;

  return (
    <div className="store-details">
      <StoreName className="store-name" name={name} storeId={storeId} />
      <StoreAddress className="store-address" address={address} />
      <StoreDistance className="store-distance" distance={distance} />
    </div>
  );

};

export const StoreDetailsPlaceholder = () => {
  return (
    <div className="store-details">
      <Placeholder type="text" height="30px" width="250px" />
      <br />
      <Placeholder type="rect" height="20px" width="200px" />
      <Placeholder type="rect" height="20px" width="150px" />
      <br />
      <Placeholder type="rect" height="20px" width="100px" />
    </div>
  );
};

StoreDetails.propTypes = {
  store: shape({}).isRequired
};
